import styled from 'styled-components'
import { getCssFromTheme } from '../../../utils/css'

export const StyledCheckboxWrapper = styled.div`
  ${({ theme, labelType }) => getCssFromTheme(theme, labelType)};
  display: flex;
  position: relative;
  cursor: pointer;
  align-items: center;

  &.disabled {
    cursor: not-allowed;
    color: ${({ theme: { color } }) => color.general.light};
    & input {
      cursor: not-allowed;
    }
    svg {
      > circle {
        fill: ${({ theme: { color } }) => color.general.lighter};
      }
      rect {
        fill: ${({ theme: { color } }) => color.general.lighter};
        stroke: ${({ theme: { color } }) => color.general.lighter};
      }
      g {
        filter: none;
      }
    }
  }

  & input {
    position: absolute;
    z-index: 1;
    opacity: 0;
    width: 20px;
    cursor: pointer;
    height: 20px;
  }

  & .typography {
    margin-left: 10px;
  }
`
